<template>
    <a-modal :title="$t('hotel.tax_classification_code' /* 税收分类编码 */)" :visible="visible" :width="'72%'" :footer="null" @cancel="handleCancel">
        <a-input-search v-model="keyword" :placeholder="$t('hotel.please_enter_content' /* 请输入需要查询的内容 */)" enter-button @search="onSearch" @keyup.enter="onSearch" />
        <div class="flex" style="height: 700px">
            <div style="flex: 0 0 300px; overflow-y: scroll" class="mt20">
                <a-tree :tree-data="treeData" :show-line="showLine" :show-icon="showIcon" :load-data="loadData" @select="onSelect">
                    <template #title="{ title }">
                        <span>{{ title }}</span>
                    </template>
                </a-tree>
            </div>
            <div class="flex-item" style="width: 0">
                <a-table ref="table" size="small" :rowKey="record => record.category_id" :columns="columns" :dataSource="dataList" :pagination="false" class="mt20" :scroll="{ x: 2200, y: 600 }">
                    <span slot="merge_first_level" slot-scope="text">
                        {{ text == 'Y' ? $t('formConfig.yes' /* 是 */) : $t('formConfig.no' /* 否 */) }}
                    </span>

                    <span slot="action" slot-scope="text, recode">
                        <div class="flex">
                            <a-button type="link" @click="handleSelect(recode)">{{ $t('web.selected' /* 选中 */) }}</a-button>
                        </div>
                    </span>
                </a-table>
            </div>
        </div>
    </a-modal>
</template>

<script>
import addCommodity from './add-commodity.vue';
export default {
    components: { addCommodity },
    data() {
        return {
            form: this.$form.createForm(this),
            visible: false,
            // 分页
            pagination: {
                page: 1,
                limit: 10
            },
            paginationTotal: 0,
            dataList: [],
            showLine: true,
            showIcon: false,
            treeData: [],
            keyword: '',
            columns: [
                {
                    title: this.$t('hotel.code' /* 编码 */),
                    dataIndex: 'code',
                    align: 'center',
                    fixed: 'left',
                    width: 130
                },
                {
                    title: this.$t('hotel.concat_code' /* 合并编码 */),
                    dataIndex: 'merge_coding',
                    width: 200,
                    align: 'center'
                    // scopedSlots: { customRender: "real_name" },
                },
                {
                    title: this.$t('hotel.goods_activity_name' /* 货物和劳动名称 */),
                    dataIndex: 'goods_name',
                    width: 170,
                    align: 'center'
                },
                {
                    title: this.$t('hotel.tax_simple_name' /* 税收分类简称 */),
                    dataIndex: 'short_name',
                    width: 170,
                    align: 'center'
                },
                {
                    title: this.$t('web.desc' /* 说明 */),
                    dataIndex: 'explained',
                    align: 'center',
                    width: 400
                },
                {
                    title: this.$t('hotel.add_tax_rate' /* 增值税税率 */),
                    dataIndex: 'tax_rate_desc',
                    width: 120,
                    align: 'center'
                },
                {
                    title: this.$t('hotel.add_tax_management' /* 增值税特殊管理 */),
                    dataIndex: 'added_tax_special',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.add_tax_by' /* 增值税政策依据 */),
                    dataIndex: 'added_tax_basis',
                    align: 'center'
                },
                {
                    title: this.$t('web.keyword' /* 关键字 */),
                    dataIndex: 'keyword',
                    align: 'center'
                },
                {
                    title: this.$t('hotel.summary' /* 汇总 */),
                    dataIndex: 'merge_first_level',
                    width: 90,
                    scopedSlots: { customRender: 'merge_first_level' },
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    fixed: 'right',
                    width: 90
                }
            ]
        };
    },
    methods: {
        // 选中
        handleSelect(recode) {
            this.$emit('handleSelect', recode);
            this.handleCancel();
        },
        onSelect(selectedKeys, info) {
            this.getDataList(selectedKeys[0]);
        },
        // 获取根节点数据
        getHeadNode() {
            this.$request.get({ url: 'getHeadNode' }).then(res => {
                this.treeData = res.data.map(item => ({
                    title: item.goods_name,
                    key: item.merge_coding,
                    isLeaf: item.merge_first_level === 'N',
                    merge_first_level: item.merge_first_level
                }));
            });
        },
        // 加载子节点数据
        loadData(treeNode) {
            // 如果节点已经有子节点，不再加载
            if (treeNode.dataRef.children) {
                return;
            }
            // 获取子节点数据
            this.$request
                .get({
                    url: 'getHeadCategory',
                    data: { merge_coding: treeNode.dataRef.key }
                })
                .then(res => {
                    const children = res.data.map(item => ({
                        title: item.goods_name,
                        key: item.merge_coding,
                        isLeaf: item.merge_first_level === 'N',
                        merge_first_level: item.merge_first_level
                    }));

                    treeNode.dataRef.children = children;

                    // 触发视图更新
                    this.treeData = [...this.treeData];
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });
        },

        show() {
            this.visible = true;
            this.getHeadNode();
        },
        onClose() {
            this.visible = false;
        },
        // 切换分页
        handlePaginationChangeEvent(page, limit) {
            this.pagination = {
                page,
                limit
            };
        },

        // 税率接口
        getInvoiceTaxList(channel_id) {
            let data = {
                channel_id
            };
            this.$request.get({ url: 'getInvoiceTaxList', data }).then(res => {
                this.taxList = res.data;
            });
        },
        // 获取表格数据
        getDataList(merge_coding) {
            let data = {
                merge_coding,
                keyword: this.keyword,
                ...this.pagination
            };
            this.$request.get({ url: 'getTaxChildTable', data }).then(res => {
                this.paginationTotal = res.data.totalCount;
                this.dataList = res.data.data;
            });
        },
        onSearch() {
            this.pagination.page = 1;
            this.getDataList('1000000000000000000');
        },
        handleCancel() {
            this.visible = false;
        }
    }
};
</script>
  